import { render, staticRenderFns } from "./VpsDetails.vue?vue&type=template&id=9000afe8&"
import script from "./VpsDetails.vue?vue&type=script&lang=js&"
export * from "./VpsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports